/*
 * @Author: mikey.zhaopeng
 * @Date: 2022-01-Sa 09:58:07
 * @Last Modified by:   mikey.zhaopeng
 * @Last Modified time: 2022-01-Sa 09:58:07
 */
<template>
  <div class="main" v-loading="loading">
    <div class="top_title">{{ $t("customProduct.CustomProduct") }}</div>
    <emptyData v-if="isEmpty"></emptyData>
    <template v-else>
      <div class="f-b bg-white">
        <div class="f--c" style="height: 60px; padding-left: 14px">
          <el-select
            style="width: 140px; margin-right: 10px"
            v-model="searchParams.status"
            :placeholder="$t('customProduct.Status')"
            clearable
            @change="resetPage"
          >
            <el-option
              :value="1"
              :label="$t('customProduct.Unreceived')"
            ></el-option>
            <el-option
              :value="2"
              :label="$t('customProduct.Received')"
            ></el-option>
            <el-option
              :value="3"
              :label="$t('customProduct.Completed')"
            ></el-option>
            <el-option
              :value="4"
              :label="$t('customProduct.Canceled')"
            ></el-option>
            <el-option
              :value="5"
              :label="$t('customProduct.Published')"
            ></el-option>
          </el-select>
          <el-select
            style="width: 200px; margin-right: 10px"
            :placeholder="$t('customProduct.SampleFee')"
            v-model="searchParams.paymentStatus"
            clearable
            @change="resetPage"
          >
            <el-option :value="0" :label="'-'"></el-option>
            <el-option
              :value="1"
              :label="$t('customProduct.Unpaid')"
            ></el-option>
            <el-option :value="2" :label="$t('customProduct.Paid')"></el-option>
            <el-option :value="3" label="Canceled"></el-option>
          </el-select>
          <el-input
            :placeholder="$t('customProduct.inputPlaceholder')"
            class="inputGroup"
            v-model="searchParams.searchContent"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              round
              type="primary"
              @click="resetPage"
            ></el-button>
          </el-input>
        </div>
        <div style="height: 60px; padding-right: 15px" class="f--c">
          <el-button
            type="primary"
            round
            @click="$router.push('/commodity/customProduct/add')"
            >{{ $t("customProduct.AddNewDemand") }}</el-button
          >
        </div>
      </div>
      <div class="bg-white" style="padding: 0 14px">
        <el-table
          :data="tableData"
          style="width: 100%"
          row-key="id"
          ref="tableData"
        >
          <el-table-column
            :label="$t('customProduct.Product')"
            prop="product"
            class-name="product_columns"
            width="300"
          >
            <template slot-scope="scope">
              <div class="f" style="height: 95px">
                <div style="margin: 0px 8px 0 0; padding-top: 10px">
                  <el-popover placement="right" width="280" trigger="hover">
                    <el-image fit="cover" :src="scope.row.imageUrl"></el-image>
                    <el-image style="width: 64px;height: 64px" :src="scope.row.imageUrl" slot="reference"></el-image>
                  </el-popover>
                </div>
                <div class="product_title">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.productName"
                    placement="top"
                  >
                    <div class="ellipsis2">{{ scope.row.productName }}</div>
                  </el-tooltip>
                  <div>
                    {{ $t("customProduct.DemandNo") }}：
                    <el-button type="text" @click="dropdowmClick('detail', scope.row)">{{ scope.row.demandNo }}</el-button>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('customProduct.AddedTime')">
            <template slot-scope="scope">
              {{ scope.row.createDate | timeToString }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('customProduct.DemandStatus')">
            <template slot-scope="scope">
              {{ StatusPoint[scope.row.status] }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('customProduct.PaymentStatus')">
            <template slot-scope="scope">
              {{ SampleFeePoint[scope.row.paymentStatus] }}
            </template>
          </el-table-column>
          <el-table-column label="type" width="210">
            <template slot-scope="scope">
              <div v-if="+scope.row.type === 1" style="width:100%" class="f--c">
                <div style="width:40px;height:40px;margin-right:4px;">
                  <oss-img :src="customizeOnDemandImage" :width="20" :height="20"></oss-img>
                </div>
                <div>{{ $t('Publish.CustomProduct.List.Index.CustomizeOnDemand') }}</div>
              </div>
              <div v-else class="f--c">
                <!-- <div style="width:40px;height:40px;margin-right:4px">
                  <oss-img :src="scope.row.podStyle.split(',')[0] | podStyleImage" :width="20" :height="20"></oss-img>
                </div>
                <div>{{scope.row.podStyle.split(',')[0] | podStyleText}}</div> -->
                <div style="width:40px;height:40px;margin-right:4px;">
                  <oss-img src="https://img.kakaclo.com/web-img/print_customize/PrintOnDemand.png" :width="20" :height="20"></oss-img>
                </div>
                <div>{{ $t('Publish.CustomProduct.List.Index.PrintOnDemand') }}</div>
              </div>
              <!-- {{scope.row.type}} -->
            </template>
          </el-table-column>
          <el-table-column :label="$t('customProduct.Action')" width="160">
            <template slot-scope="scope">
              <div>
                <el-link
                  v-if="[1].includes(scope.row.paymentStatus)"
                  style="margin-right: 10px; color: #99c41c"
                  @click="dropdowmClick('PaySampleFee', scope.row)"
                  >
                  {{ $t("customProduct.PayNow") }}</el-link
                >
                <el-link
                  v-else
                  style="margin-right: 10px; color: #99c41c"
                  @click="dropdowmClick('detail', scope.row)"
                  >
                  {{ $t("customProduct.Details") }}</el-link
                >
                <el-dropdown
                  @command="(command) => dropdowmClick(command, scope.row)"
                >
                  <span class="el-dropdown-link">
                    <el-link style="color: #99c41c">{{
                      $t("customProduct.More")
                    }}</el-link
                    ><i
                      class="el-icon-arrow-down el-icon--right actionColor"
                    ></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      command="Edit"
                      v-if="[1, 4].includes(scope.row.status)"
                      >{{ $t("customProduct.Edit") }}</el-dropdown-item
                    >
                    <!-- <el-dropdown-item
                      command="PaySampleFee"
                      v-if="[1].includes(scope.row.paymentStatus)"
                      >{{ $t("customProduct.PaySampleFee") }}</el-dropdown-item
                    > -->
                    <el-dropdown-item
                      command="detail"
                      v-if="[1].includes(scope.row.paymentStatus)"
                      >{{ $t("customProduct.Details") }}</el-dropdown-item
                    >
                    <el-dropdown-item command="PaymentRecords" v-if="[1, 2, 3].includes(scope.row.paymentStatus)">{{
                      $t("customProduct.PaymentRecords")
                    }}</el-dropdown-item>
                    <el-dropdown-item
                      command="Cancel"
                      v-if="[1].includes(scope.row.status)"
                      >{{ $t("customProduct.Cancel") }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="f-e bg-white">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 200]"
          :total="total"
          class="myPagination"
          :current-page.sync="listForm.pageNumber"
          :page-size="listForm.pageSize"
          @current-change="pageCurrentChange"
          @size-change="pageSizeChange"
        />
      </div>
    </template>
    <PaymentRecordsDialog ref="PaymentRecordsDialog"></PaymentRecordsDialog>
    <PaySampleFee ref="PaySampleFee"></PaySampleFee>
  </div>
</template>

<script>
import API from '@/api'
import PaymentRecordsDialog from './components/PaymentRecordsDialog'
import PaySampleFee from './components/PaySampleFee'
import emptyData from './components/emptyData.vue'
import { PODImageMap, customizeOnDemandImage } from '@/views/home/customized/data.js'
export default {
  components: { PaymentRecordsDialog, PaySampleFee, emptyData },
  data() {
    return {
      tableData: [],
      listForm: {
        pageNumber: 1,
        pageSize: 20,
        listingStatus: 1
      },
      total: 0,
      searchParams: {
        searchContent: undefined,
        status: undefined,
        paymentStatus: undefined,
        requestType: 1
      },
      srcList: [],
      loading: false,
      isEmpty: false,
      customizeOnDemandImage
    }
  },
  created() {
    this.getList()
  },
  filters: {
    podStyleImage(value) {
      const target = PODImageMap.find(e => +e.value === +value)
      return target.url
    },
    podStyleText(value) {
      const target = PODImageMap.find(e => +e.value === +value)
      return target.text
    }
  },
  computed: {
    StatusPoint() {
      const obj = {
        1: this.$t('customProduct.Unreceived'),
        2: this.$t('customProduct.Received'),
        3: this.$t('customProduct.Completed'),
        4: this.$t('customProduct.Canceled'),
        5: this.$t('customProduct.Published')
      }
      return obj
    },
    SampleFeePoint() {
      const obj = {
        0: '-',
        1: this.$t('customProduct.Unpaid'),
        2: this.$t('customProduct.Paid'),
        3: 'Canceled'
      }
      return obj
    }
  },
  methods: {
    getParams() {
      const params = Object.assign({}, this.listForm, this.searchParams)
      return params
    },
    async getList() {
      try {
        const params = this.getParams()
        this.loading = true
        let res = await API.getProductCustomList(params)
        this.tableData = res.data.list
        this.total = res.data.total
        this.srcList = this.tableData.map((e) => e.imageUrl)
        this.loading = false
        this.dataIsEmpty()
      } catch (error) {
        this.loading = false
      }
    },
    // 用户是否没有数据
    dataIsEmpty() {
      let isEmpty = Object.keys(this.searchParams).every((key) => {
        if (key === 'requestType') return true
        return !this.searchParams[key]
      })
      this.isEmpty = (isEmpty && this.total === 0)
    },
    pageCurrentChange(page) {
      this.listForm.page = page
      this.getList()
    },
    // 表格操作按钮
    async dropdowmClick(command, row) {
      console.log(row)
      switch (command) {
        case 'Edit':
          this.$router.push({
            path: '/commodity/customProduct/edit',
            query: {
              id: row.id
            }
          })
          break
        case 'PaySampleFee':
          this.$refs.PaySampleFee.show(row)
          break
        case 'PaymentRecords':
          this.$refs.PaymentRecordsDialog.show(row)
          break
        case 'Cancel':
          this.loading = true
          API.customProductCustomStatus({
            operationType: 6,
            id: row.id,
            userId: this.$store.state.common.userId,
            userName: this.$store.state.common.userName
          }).then(res => {
            if (res.code === 10000) {
              this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }).finally(() => {
            this.loading = false
          })
          break
        case 'detail':
          this.$router.push({
            path: '/commodity/customProduct/detail',
            query: {
              id: row.id
            }
          })
          break
        default:
          break
      }
    },
    resetPage() {
      this.listForm.pageNumber = 1
      this.getList()
    },
    pageSizeChange(pageSize) {
      this.listForm.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.top_title {
  font-size: 18px;
  font-weight: 550;
  height: 60px;
  line-height: 60px;
}
.inputGroup {
  width: 450px;
  /deep/.el-input__inner {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
  /deep/.el-input-group__append {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    background-color: rgba(153, 196, 28, 0.2);
  }
}
.myPagination {
  padding: 8px 5px;
  /deep/.number {
    border: 1px solid #d9d9d9;
    margin: 0 5px;
    padding: 0;
    min-width: 30px;
  }
}
.product_title {
  padding-top: 10px;
  //   height: 100%;
  > div:nth-of-type(1) {
    font-size: 14px;
  }
  > div:nth-of-type(2) {
    font-size: 12px;
    color: #747a87;
  }
}
.actionColor {
  color: #99c41c;
}
.addButton {
  background: rgba(153, 196, 28, 0.2);
  border-color: rgba(153, 196, 28, 0.2);
  color: #9aca0e;
}
</style>

<style lang="scss">
.product_columns {
  display: flex;
  .cell {
    display: flex;
    align-items: center;
  }
}
</style>
